/**
 * ComfoFeet — MEN / WOMEN size display converter (product pages)
 * Converts men's US size labels to women's equivalents for display only.
 * Supports "US 8", "US Men 8", and pill data-value attributes.
 */
(function () {
  'use strict';

  if (window.__igSizeGenderConverterBooted) return;
  window.__igSizeGenderConverterBooted = true;

  var VARIANT_MAP = {
    'US 4': 'US 6',
    'US 4.5': 'US 6.5',
    'US 5': 'US 7',
    'US 5.5': 'US 7.5',
    'US 6': 'US 8',
    'US 6.5': 'US 8.5',
    'US 7': 'US 9',
    'US 7.5': 'US 9.5',
    'US 8': 'US 10',
    'US 8.5': 'US 10.5',
    'US 9': 'US 11',
    'US 9.5': 'US 11.5',
    'US 10': 'US 12',
    'US 10.5': 'US 12.5',
    'US 11': 'US 13',
    'US 11.5': 'US 13.5',
    'US 12': 'US 14',
    'US 12.5': 'US 14.5',
    'US 13': 'US 15',
    'US 13.5': 'US 15.5',
    'US 14': 'US 16',
    'US 14.5': 'US 16.5',
    'US 15': 'US 17',
    'US 15.5': 'US 17.5',
    'US 16': 'US 18',
    'US 16.5': 'US 18.5',
    'US 17': 'US 19',
    'US 17.5': 'US 19.5',
    'US 18': 'US 20',
    'US 18.5': 'US 20.5',
    'US 19': 'US 21',
    'US 19.5': 'US 21.5',
    'US 20': 'US 22',
  };

  var REVERSE_MAP = Object.keys(VARIANT_MAP).reduce(function (acc, key) {
    acc[VARIANT_MAP[key]] = key;
    return acc;
  }, {});

  var activeGender = 'men';
  var userSelectedGender = 'men';
  var genderLockedByUser = false;
  var debounceTimer;
  var isUpdating = false;
  var genderObserver = null;
  var tabsBound = false;
  var PROP_GENDER = 'Gender';
  var PROP_DISPLAY_SIZE = '_Display Size';
  var STORAGE_KEY = 'igCartGenderMap';
  var cartTimer = null;
  var rewritingCart = false;
  var cartObserverBound = false;
  var lastCartItems = [];
  var lastCartSig = '';

  function isDualGenderSize(text) {
    if (!text) return false;
    return /^US\s*Men\s*\d+(?:\.\d+)?\s*-\s*(?:US\s*)?Women\s*\d+(?:\.\d+)?$/i.test(
      String(text).trim()
    );
  }

  function parseDualGenderSize(text) {
    var match = String(text)
      .trim()
      .match(/^US\s*Men\s*(\d+(?:\.\d+)?)\s*-\s*(?:US\s*)?Women\s*(\d+(?:\.\d+)?)$/i);
    if (!match) return null;
    return {
      men: 'US Men ' + match[1],
      women: 'US Women ' + match[2],
    };
  }

  function normalizeSizeKey(text) {
    if (!text) return null;
    var value = String(text).trim();
    var dual = parseDualGenderSize(value);
    if (dual) return normalizeSizeKey(dual.men);
    var match = value.match(/^US(?:\s*(?:Men|Women))?\s*(\d+(?:\.\d+)?)$/i);
    if (!match) return null;
    return 'US ' + match[1];
  }

  function formatWomenSize(original, womenPlain) {
    var womenNumber = womenPlain.replace(/^US\s*/i, '');
    // Display as plain US size (no "Women" word in the UI).
    return 'US ' + womenNumber;
  }

  function cartDisplaySize(original) {
    if (!original) return '';
    var dual = parseDualGenderSize(original);
    if (dual) {
      return normalizeSizeKey(dual.women) || dual.women;
    }
    var key = normalizeSizeKey(original);
    if (!key) return String(original).trim();
    return VARIANT_MAP[key] || key;
  }

  function formatMenSize(original, menPlain) {
    var menNumber = String(menPlain || '').replace(/^US\s*/i, '');
    // Display as plain US size (no "Men"/"Women" word in the UI).
    return 'US ' + menNumber;
  }

  function isConvertibleSize(text) {
    if (isDualGenderSize(text)) return true;
    var key = normalizeSizeKey(text);
    return !!(key && (VARIANT_MAP[key] || REVERSE_MAP[key]));
  }

  function isSizeRow(row) {
    if (!row) return false;
    var label = row.querySelector('.form__label');
    if (label && /size/i.test(label.textContent || '')) return true;

    var select = row.querySelector('select.select__select');
    if (!select) return false;

    var options = select.querySelectorAll('option');
    var convertible = 0;
    for (var i = 0; i < options.length; i++) {
      if (isConvertibleSize(options[i].value)) convertible++;
    }
    return convertible >= Math.max(1, Math.ceil(options.length * 0.5));
  }

  function findSizeRow(variantSelects) {
    var rows = variantSelects.querySelectorAll(':scope > .product-form__input');
    for (var i = 0; i < rows.length; i++) {
      if (isSizeRow(rows[i])) return rows[i];
    }
    return null;
  }

  function productSupportsGenderToggle() {
    var variantSelects = document.querySelector('variant-selects.custom-variant-flex');
    if (!variantSelects) return false;
    return !!findSizeRow(variantSelects);
  }

  function getCanonicalOriginal(el) {
    if (!el) return null;
    if (el.tagName === 'OPTION' && el.value) return el.value.trim();
    var dataValue = el.getAttribute && el.getAttribute('data-value');
    if (dataValue) return dataValue.trim();
    return null;
  }

  function rememberOriginal(el, text) {
    var source = getCanonicalOriginal(el) || text;
    if (!el.dataset.originalSize && isConvertibleSize(source)) {
      el.dataset.originalSize = source;
    }
  }

  function resolveUiGender() {
    // Size/color/bundle changes must NEVER flip gender. Only explicit user
    // gender controls (MEN/WOMEN tabs or sticky gender select) update this.
    return userSelectedGender === 'women' ? 'women' : 'men';
  }

  function syncGenderUi(gender) {
    activeGender = gender === 'women' ? 'women' : 'men';
    userSelectedGender = activeGender;

    document.querySelectorAll('.custom-gender-tab').forEach(function (btn) {
      btn.classList.toggle('active', btn.getAttribute('data-gender') === activeGender);
    });

    document.querySelectorAll('[data-sticky-atc-gender-select]').forEach(function (select) {
      if (select.value !== activeGender) select.value = activeGender;
    });

    document
      .querySelectorAll('.sticky-atc-gender-ab__btn[data-gender]')
      .forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-gender') === activeGender);
      });
  }

  function setUserGender(gender, fromUser) {
    var next = gender === 'women' ? 'women' : 'men';
    if (fromUser) genderLockedByUser = true;
    syncGenderUi(next);
  }

  function displayForGenderValue(original, gender) {
    var dual = parseDualGenderSize(original);
    if (dual) {
      if (gender === 'women') {
        return 'US ' + dual.women.replace(/^US\s*(?:Women\s*)?/i, '');
      }
      return 'US ' + dual.men.replace(/^US\s*(?:Men\s*)?/i, '');
    }

    var raw = String(original || '').trim();
    var key = normalizeSizeKey(raw);
    if (!key) return raw;

    var isWomenLabeled = /^US\s*Women\s/i.test(raw);
    var isMenLabeled = /^US\s*Men\s/i.test(raw);

    if (gender === 'women') {
      if (isWomenLabeled) {
        return 'US ' + key.replace(/^US\s*/i, '');
      }
      if (VARIANT_MAP[key]) return formatWomenSize(raw, VARIANT_MAP[key]);
      return formatWomenSize(raw, key);
    }

    // Men view: if catalog/label is women-sized, reverse-map back to men.
    if (isWomenLabeled && REVERSE_MAP[key]) {
      return formatMenSize(raw, REVERSE_MAP[key]);
    }
    if (isMenLabeled || VARIANT_MAP[key] || REVERSE_MAP[key]) {
      return formatMenSize(raw, key);
    }
    return raw;
  }

  function displayForGender(original) {
    return displayForGenderValue(original, activeGender);
  }

  function isAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.getAttribute('data-type') === 'add-to-cart-form') return true;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add/i.test(action);
  }

  function ensurePropertyInput(form, name) {
    var selector = 'input[name="properties[' + name + ']"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    return input;
  }

  function currentVariantId() {
    var input = document.querySelector(
      'product-form form [name="id"], form[data-type="add-to-cart-form"] [name="id"]'
    );
    return input && input.value ? String(input.value) : '';
  }

  function currentGenderProperties() {
    activeGender = resolveUiGender();
    var original = getActiveSizeOriginal();
    var displaySize =
      activeGender === 'women' && original ? cartDisplaySize(original) : '';
    return {
      gender: activeGender === 'women' ? 'Women' : 'Men',
      displaySize: displaySize,
    };
  }

  function syncPropertyInputs() {
    if (!productSupportsGenderToggle()) return;
    var props = currentGenderProperties();
    document.querySelectorAll('form').forEach(function (form) {
      if (!isAddToCartForm(form)) return;
      ensurePropertyInput(form, PROP_GENDER).value = props.gender;
      var displayInput = ensurePropertyInput(form, PROP_DISPLAY_SIZE);
      if (props.displaySize) {
        displayInput.value = props.displaySize;
      } else {
        displayInput.remove();
      }
    });
  }

  function readGenderMap() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function rememberCurrentAdd() {
    var props = currentGenderProperties();
    var id = currentVariantId();
    if (!id) return;
    var map = readGenderMap();
    map[id] = {
      gender: String(props.gender || '').toLowerCase(),
      displaySize: props.displaySize || '',
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function shouldAttachGenderProps() {
    return !!productSupportsGenderToggle();
  }

  function assignGenderProperties(target) {
    var props = currentGenderProperties();
    if (!target.properties || typeof target.properties !== 'object') target.properties = {};
    target.properties[PROP_GENDER] = props.gender;
    if (props.displaySize) {
      target.properties[PROP_DISPLAY_SIZE] = props.displaySize;
    } else {
      delete target.properties[PROP_DISPLAY_SIZE];
    }
  }

  function injectGenderIntoFetchInit(init) {
    if (!init || !shouldAttachGenderProps()) return init;
    var body = init.body;
    if (!body) return init;
    var variantId = currentVariantId();
    var props = currentGenderProperties();

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (variantId && String(body.get('id') || '') !== variantId) return init;
      body.set('properties[' + PROP_GENDER + ']', props.gender);
      if (props.displaySize) {
        body.set('properties[' + PROP_DISPLAY_SIZE + ']', props.displaySize);
      } else {
        body.delete('properties[' + PROP_DISPLAY_SIZE + ']');
      }
      return init;
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      if (variantId && String(body.get('id') || '') !== variantId) return init;
      body.set('properties[' + PROP_GENDER + ']', props.gender);
      if (props.displaySize) {
        body.set('properties[' + PROP_DISPLAY_SIZE + ']', props.displaySize);
      } else {
        body.delete('properties[' + PROP_DISPLAY_SIZE + ']');
      }
      return init;
    }

    if (typeof body !== 'string') return init;
    try {
      var json = JSON.parse(body);
      if (json.items && json.items.length) {
        json.items.forEach(function (item) {
          if (!variantId || String(item.id) === variantId) assignGenderProperties(item);
        });
      } else if (!variantId || String(json.id) === variantId) {
        assignGenderProperties(json);
      } else {
        return init;
      }
      var next = {};
      var key;
      for (key in init) {
        if (Object.prototype.hasOwnProperty.call(init, key)) next[key] = init[key];
      }
      next.body = JSON.stringify(json);
      return next;
    } catch (e) {
      return init;
    }
  }

  function patchCartAddFetch() {
    if (window.__igGenderFetchPatched || typeof window.fetch !== 'function') return;
    window.__igGenderFetchPatched = true;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add/i.test(url)) {
          rememberCurrentAdd();
          syncPropertyInputs();
          init = injectGenderIntoFetchInit(init || {});
        }
      } catch (e) {}
      return originalFetch.call(this, input, init);
    };
  }

  function getLineProp(properties, name) {
    if (!properties) return '';
    if (properties[name] != null && properties[name] !== '') return String(properties[name]);
    var key;
    for (key in properties) {
      if (!Object.prototype.hasOwnProperty.call(properties, key)) continue;
      if (String(key).toLowerCase() === name.toLowerCase() && properties[key] != null) {
        return String(properties[key]);
      }
    }
    return '';
  }

  function patchCartAddXHR() {
    if (window.__igGenderXHRPatched || !window.XMLHttpRequest) return;
    window.__igGenderXHRPatched = true;
    var proto = XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      this.__igCartAdd = /\/cart\/add/i.test(String(url || ''));
      return originalOpen.apply(this, arguments);
    };

    proto.send = function (body) {
      if (this.__igCartAdd) {
        rememberCurrentAdd();
        syncPropertyInputs();
        try {
          if (typeof FormData !== 'undefined' && body instanceof FormData) {
            var props = currentGenderProperties();
            var variantId = currentVariantId();
            if (!variantId || String(body.get('id') || '') === variantId) {
              body.set('properties[' + PROP_GENDER + ']', props.gender);
              if (props.displaySize) {
                body.set('properties[' + PROP_DISPLAY_SIZE + ']', props.displaySize);
              } else {
                body.delete('properties[' + PROP_DISPLAY_SIZE + ']');
              }
            }
          } else if (typeof body === 'string' && body.charAt(0) === '{') {
            var json = JSON.parse(body);
            var variantIdJson = currentVariantId();
            if (json.items && json.items.length) {
              json.items.forEach(function (item) {
                if (!variantIdJson || String(item.id) === variantIdJson) {
                  assignGenderProperties(item);
                }
              });
            } else if (!variantIdJson || String(json.id) === variantIdJson) {
              assignGenderProperties(json);
            }
            body = JSON.stringify(json);
          }
        } catch (e) {}
      }
      return originalSend.call(this, body);
    };
  }

  function womenCartLabel(item) {
    if (!item) return null;
    var map = readGenderMap();
    var rec = map[String(item.variant_id)] || map[String(item.id)] || null;
    var gender =
      getLineProp(item.properties, PROP_GENDER).toLowerCase() ||
      getLineProp(item.properties, '_Gender').toLowerCase();
    if (!gender && rec) gender = String(rec.gender || '').toLowerCase();
    if (
      gender !== 'women' &&
      activeGender === 'women' &&
      currentVariantId() &&
      String(item.variant_id) === currentVariantId()
    ) {
      gender = 'women';
    }
    if (gender !== 'women') return null;

    var displaySize = getLineProp(item.properties, PROP_DISPLAY_SIZE).replace(
      /^US\s*Women\s+/i,
      'US '
    );
    if (!displaySize && rec && rec.displaySize) displaySize = rec.displaySize;

    var title = String(item.variant_title || '').trim();
    var parsed = title.match(/^(.+?)\s*\/\s*(.+)$/);
    if (!displaySize && parsed) displaySize = cartDisplaySize(parsed[2]);
    if (!displaySize) displaySize = cartDisplaySize(title);
    if (!displaySize) return null;
    if (parsed) return parsed[1].trim() + ' / ' + displaySize;
    return displaySize;
  }

  function queryAllDeep(selector, root) {
    var results = [];
    function walk(node) {
      if (!node) return;
      if (node.querySelectorAll) {
        try {
          node.querySelectorAll(selector).forEach(function (el) {
            results.push(el);
            if (el.shadowRoot) walk(el.shadowRoot);
          });
        } catch (e) {}
      }
      if (node.shadowRoot) walk(node.shadowRoot);
    }
    walk(root || document);
    return results;
  }

  function walkTextNodes(root, fn) {
    if (!root) return;
    if (root.nodeType === 3) {
      fn(root);
      return;
    }
    if (root.shadowRoot) walkTextNodes(root.shadowRoot, fn);
    if (root.querySelectorAll) {
      try {
        root.querySelectorAll('*').forEach(function (el) {
          if (el.shadowRoot) walkTextNodes(el.shadowRoot, fn);
        });
      } catch (e) {}
    }
    if (!root.createTreeWalker && root.ownerDocument) {
      root = root.ownerDocument;
    }
    var doc = root.nodeType === 9 ? root : root.ownerDocument || document;
    if (!doc.createTreeWalker) return;
    try {
      var walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) fn(node);
    } catch (e) {}
  }

  function replaceLeafText(root, fromText, toText) {
    if (!root || !fromText || !toText || fromText === toText) return;
    walkTextNodes(root, function (node) {
      var value = node.nodeValue;
      if (!value || value.indexOf(fromText) === -1) return;
      node.nodeValue = value.split(fromText).join(toText);
    });
  }

  function rewriteCartItems(items) {
    if (rewritingCart || !items || !items.length) return;
    var sig = items
      .map(function (item) {
        return [
          item.variant_id || item.id,
          getLineProp(item.properties, PROP_GENDER),
          getLineProp(item.properties, PROP_DISPLAY_SIZE),
        ].join(':');
      })
      .join('|');
    rewritingCart = true;
    try {
      var cartRoots = [];
      document
        .querySelectorAll(
          'upcart-cart-drawer, #upcart, [id^="upcart"], [id*="upcart"], [class*="upcart"], [class*="UpCart"], cart-drawer, #CartDrawer, cart-notification'
        )
        .forEach(function (el) {
          cartRoots.push(el);
          if (el.shadowRoot) cartRoots.push(el.shadowRoot);
        });
      if (!cartRoots.length) return;

      items.forEach(function (item) {
        var nextLabel = womenCartLabel(item);
        var fromLabel = String(item.variant_title || '').trim();
        if (!nextLabel || !fromLabel || nextLabel === fromLabel) return;

        cartRoots.forEach(function (root) {
          replaceLeafText(root, fromLabel, nextLabel);
          var parsed = fromLabel.match(/^(.+?)\s*\/\s*(.+)$/);
          var nextParsed = nextLabel.match(/^(.+?)\s*\/\s*(.+)$/);
          if (parsed && nextParsed && parsed[2].trim() !== nextParsed[2].trim()) {
            replaceLeafText(root, parsed[2].trim(), nextParsed[2].trim());
          }
        });
      });
      lastCartSig = sig;
    } finally {
      setTimeout(function () {
        rewritingCart = false;
      }, 50);
    }
  }

  function fetchAndRewriteCart() {
    if (rewritingCart) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        lastCartItems = (cart && cart.items) || [];
        rewriteCartItems(lastCartItems);
        setTimeout(function () {
          rewriteCartItems(lastCartItems);
        }, 400);
      })
      .catch(function () {});
  }

  function scheduleCartUpdate() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(fetchAndRewriteCart, 180);
  }

  function isCartNode(node) {
    if (!node || node.nodeType !== 1) return false;
    if (
      node.matches &&
      node.matches(
        'upcart-cart-drawer, #upcart, [id^="upcart"], [class*="upcart"], cart-drawer, #CartDrawer, cart-notification'
      )
    ) {
      return true;
    }
    return !!(
      node.querySelector &&
      node.querySelector(
        'upcart-cart-drawer, #upcart, [id^="upcart"], [class*="upcart"], cart-drawer, #CartDrawer, cart-notification'
      )
    );
  }

  function bindCartObserver() {
    if (cartObserverBound || !document.body || !window.MutationObserver) return;
    cartObserverBound = true;
    document.addEventListener('cart:updated', scheduleCartUpdate);
    new MutationObserver(function (mutations) {
      if (rewritingCart || isUpdating) return;
      var related = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var target = m.target;
        if (
          target &&
          target.closest &&
          target.closest(
            'upcart-cart-drawer, #upcart, [id^="upcart"], [class*="upcart"], cart-drawer, #CartDrawer, cart-notification'
          )
        ) {
          related = true;
          break;
        }
        if (target === document.body && m.attributeName === 'class') {
          related = true;
          break;
        }
        if (!m.addedNodes) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          if (isCartNode(m.addedNodes[j])) {
            related = true;
            break;
          }
        }
        if (related) break;
      }
      if (related) scheduleCartUpdate();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'open'],
    });
  }

  function clearStoredOriginals() {
    document
      .querySelectorAll('[data-original-size], [data-original-color]')
      .forEach(function (el) {
        delete el.dataset.originalSize;
        delete el.dataset.originalColor;
      });
  }

  function convertSizeOptionElement(el) {
    if (!el) return;
    if (el.closest && el.closest('sticky-atc, .sticky-atc-gender-ab__field, .sticky-atc-gender-controls')) {
      return;
    }

    var canonical = getCanonicalOriginal(el);
    var text = (el.textContent && el.textContent.trim()) || '';
    var source = canonical || text;
    if (!source) return;

    // Recover dual size from value even if text was already partially converted.
    if (canonical && isConvertibleSize(canonical)) {
      el.dataset.originalSize = canonical.trim();
    } else if (isConvertibleSize(source)) {
      rememberOriginal(el, source);
    } else if (isDualGenderSize(text) || /Women/i.test(text)) {
      // Shrine just reset label to dual format — force from value if present.
      if (canonical && isDualGenderSize(canonical)) {
        el.dataset.originalSize = canonical.trim();
      } else if (isDualGenderSize(text)) {
        el.dataset.originalSize = text;
      }
    }

    var original = el.dataset.originalSize;
    if (!original || !isConvertibleSize(original)) return;

    var converted = displayForGenderValue(original, resolveUiGender());
    if (el.textContent.trim() !== converted) el.textContent = converted;
    if (el.title && el.title !== converted) el.title = converted;
  }

  function convertQuantityBreakSizeLabelsNow() {
    activeGender = resolveUiGender();
    document
      .querySelectorAll(
        '.quantity-break__variant-select option, quantity-breaks select option, .quantity-breaks select option'
      )
      .forEach(convertSizeOptionElement);

    // Main size label above variant picker can flash dual text when QB syncs.
    document
      .querySelectorAll('.form__label span[id^="custom-label-"]')
      .forEach(function (el) {
        applySizeLabel(el, getActiveSizeOriginal());
      });

    // Main size options / pills
    document
      .querySelectorAll(
        'variant-selects.custom-variant-flex select[name^="options"] option, variant-selects.custom-variant-flex .ig-variant-pills__btn'
      )
      .forEach(function (el) {
        if (el.matches && el.matches('.ig-variant-pills__btn')) {
          var row = el.closest('.product-form__input');
          if (row && !isSizeRow(row)) return;
          var originalValue = getCanonicalOriginal(el);
          if (!originalValue || !isConvertibleSize(originalValue)) return;
          el.dataset.originalSize = originalValue.trim();
          var converted = displayForGenderValue(originalValue.trim(), activeGender);
          if (el.textContent.trim() !== converted) el.textContent = converted;
          return;
        }
        convertSizeOptionElement(el);
      });
  }

  function runImmediateLabelFix() {
    if (isUpdating) return;
    isUpdating = true;
    try {
      convertQuantityBreakSizeLabelsNow();
    } finally {
      isUpdating = false;
    }
  }

  function updateVariantSelectors() {
    activeGender = resolveUiGender();

    document
      .querySelectorAll(
        'select[name^="options"] option, .quantity-break__variant-select option, input[type="radio"][name^="options"] + label, .variant-input-wrapper label, .swatch label'
      )
      .forEach(convertSizeOptionElement);

    // Update every size pill in size rows (aria-label can change to "Size - US …").
    document.querySelectorAll('.ig-variant-pills__btn').forEach(function (btn) {
      var row = btn.closest('.product-form__input');
      if (row && !isSizeRow(row)) return;

      var originalValue = getCanonicalOriginal(btn);
      if (!originalValue) return;
      if (/\d+(?:\.\d+)?\s*\/\s*\d+(?:\.\d+)?/.test(originalValue)) return;
      if (!isConvertibleSize(originalValue)) return;

      btn.dataset.originalSize = originalValue.trim();
      var converted = displayForGender(originalValue.trim());
      if (btn.textContent.trim() !== converted) btn.textContent = converted;
    });
  }

  function getActiveSizeOriginal() {
    var variantSelects = document.querySelector('variant-selects.custom-variant-flex');
    if (variantSelects) {
      var sizeRow = findSizeRow(variantSelects);
      if (sizeRow) {
        var select = sizeRow.querySelector('select.select__select');
        if (select && select.value && isConvertibleSize(select.value)) {
          return select.value.trim();
        }

        var selectedPill = sizeRow.querySelector(
          '.ig-variant-pills__btn[aria-pressed="true"], .ig-variant-pills__btn--selected, .ig-variant-pills__btn.selected'
        );
        if (selectedPill) {
          var pillValue = getCanonicalOriginal(selectedPill);
          if (pillValue && isConvertibleSize(pillValue)) return pillValue;
        }

        var checkedInput = sizeRow.querySelector('input[type="radio"]:checked');
        if (checkedInput && checkedInput.value && isConvertibleSize(checkedInput.value)) {
          return checkedInput.value.trim();
        }
      }
    }

    var stickySize = document.querySelector(
      'sticky-atc [data-sticky-atc-mobile-size], sticky-atc [data-sticky-atc-gender-size]'
    );
    if (stickySize && stickySize.value && isConvertibleSize(stickySize.value)) {
      return stickySize.value.trim();
    }

    return null;
  }

  function isSizeLabelElement(el) {
    var text = el.textContent && el.textContent.trim();
    if (text && /^Size\s*[-:]/i.test(text)) return true;
    var row = el.closest('.product-form__input');
    return !!row && isSizeRow(row);
  }

  function applySizeLabel(el, activeOriginal) {
    if (!isSizeLabelElement(el)) return;

    var original = activeOriginal;
    if (!original) {
      var text = el.textContent && el.textContent.trim();
      var sizePart = text ? text.replace(/^Size\s*[-:]\s*/i, '').trim() : '';
      if (isConvertibleSize(sizePart)) original = sizePart;
    }
    if (!original) return;

    el.dataset.originalSize = original;
    var converted = displayForGender(original);
    var newText = 'Size - ' + converted;
    if (el.textContent.trim() !== newText) el.textContent = newText;
  }

  function isCartContext(el) {
    if (!el || !el.closest) return false;
    return !!el.closest(
      'upcart-cart-drawer, #upcart, [id^="upcart"], [class*="upcart"], cart-drawer, .cart-drawer, #CartDrawer, cart-notification, .cart-notification, #cart-notification'
    );
  }

  function updateSizeLabels() {
    var activeOriginal = getActiveSizeOriginal();

    document
      .querySelectorAll(
        '.form__label span[id^="custom-label-"], .sticky-add-to-cart span, .mobile-add-to-cart span, .bottom-cart span'
      )
      .forEach(function (el) {
        if (isCartContext(el)) return;
        applySizeLabel(el, activeOriginal);
      });
  }

  function updateFullVariantStrings() {
    document
      .querySelectorAll(
        'select[name="id"] option, .select__select option, .sticky-add-to-cart span, .bottom-cart span'
      )
      .forEach(function (el) {
        var text = el.textContent && el.textContent.trim();
        if (!text) return;
        if (isCartContext(el)) return;
        if (/\d+(?:\.\d+)?\s*\/\s*\d+(?:\.\d+)?/.test(text)) return;

        if (!el.dataset.originalSize) {
          var dualMatch = text.match(
            /^(.+?)\s*\/\s*(US\s*Men\s*\d+(?:\.\d+)?\s*-\s*(?:US\s*)?Women\s*\d+(?:\.\d+)?)$/i
          );
          var singleMatch = text.match(
            /^(.+?)\s*\/\s*(US(?:\s*(?:Men|Women))?\s*\d+(?:\.\d+)?)$/
          );
          var match = dualMatch || singleMatch;
          if (match && isConvertibleSize(match[2].trim())) {
            el.dataset.originalSize = match[2].trim();
            el.dataset.originalColor = match[1].trim();
          }
        }

        var originalSize = el.dataset.originalSize;
        var originalColor = el.dataset.originalColor;
        if (!originalSize || !originalColor) return;

        var convertedSize = displayForGender(originalSize);
        var newText = originalColor + ' / ' + convertedSize;
        if (el.textContent.trim() !== newText) {
          el.textContent = newText;
          if (el.title && el.title !== newText) el.title = newText;
        }
      });
  }

  function fixOptionLabelFormatting() {
    document.querySelectorAll('.product-form__label-container span').forEach(function (span) {
      if (isSizeLabelElement(span)) return;
      var text = span.textContent && span.textContent.trim();
      if (!text) return;
      if (/^(Color|Size)\s-\s/.test(text)) {
        span.textContent = text.replace(/^(Color|Size)\s-\s/, '$1 : ');
      }
    });
  }

  function updateVariantNames() {
    // Keep the shopper's chosen gender — do not re-infer from DOM/size strings.
    activeGender = resolveUiGender();
    syncGenderUi(activeGender);
    updateVariantSelectors();
    fixOptionLabelFormatting();
    updateSizeLabels();
    updateFullVariantStrings();
    syncPropertyInputs();
  }

  function stopObserver() {
    if (!genderObserver) return;
    genderObserver.disconnect();
    genderObserver = null;
  }

  function startObserver() {
    // Intentionally disabled — body MutationObserver caused sticky ATC flicker.
  }

  function runDebouncedUpdate() {
    if (isUpdating) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      isUpdating = true;
      updateVariantNames();
      isUpdating = false;
    }, 80);
  }

  function runTabSwitchUpdate() {
    if (isUpdating) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      isUpdating = true;
      updateVariantNames();
      isUpdating = false;
    }, 0);
  }

  function bindTabEvents() {
    if (tabsBound) return;
    var tabs = document.querySelectorAll('.custom-gender-tab');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var selectedGender = this.getAttribute('data-gender');
        if (!selectedGender) return;

        setUserGender(selectedGender, true);
        runTabSwitchUpdate();
      });
    });

    tabsBound = true;
  }

  function removeExistingTabs() {
    document.querySelectorAll('.custom-gender-tabs').forEach(function (el) {
      el.remove();
    });
    tabsBound = false;
    activeGender = 'men';
    userSelectedGender = 'men';
    clearStoredOriginals();
  }

  function createGenderTabs() {
    if (!productSupportsGenderToggle()) return false;

    var variantFlex = document.querySelector('variant-selects.custom-variant-flex');
    if (!variantFlex) return false;

    if (document.querySelector('.custom-gender-tabs')) {
      bindTabEvents();
      syncGenderUi(resolveUiGender());
      return false;
    }

    var tabsWrapper = document.createElement('div');
    tabsWrapper.className = 'custom-gender-tabs';
    tabsWrapper.innerHTML =
      '<button type="button" class="custom-gender-tab active" data-gender="men">MEN</button>' +
      '<button type="button" class="custom-gender-tab" data-gender="women">WOMEN</button>';

    variantFlex.parentNode.insertBefore(tabsWrapper, variantFlex);
    tabsBound = false;
    userSelectedGender = 'men';
    activeGender = 'men';
    bindTabEvents();
    return true;
  }

  var labelObservers = [];

  function stopLabelObservers() {
    labelObservers.forEach(function (observer) {
      observer.disconnect();
    });
    labelObservers = [];
  }

  function observeSizeLabels() {
    stopLabelObservers();

    var variantSelects = document.querySelector('variant-selects.custom-variant-flex');
    if (!variantSelects) return;

    var sizeRow = findSizeRow(variantSelects);
    if (!sizeRow) return;

    sizeRow.querySelectorAll('.form__label span[id^="custom-label-"]').forEach(function (el) {
      var observer = new MutationObserver(function () {
        if (isUpdating) return;
        applySizeLabel(el, getActiveSizeOriginal());
      });
      observer.observe(el, { childList: true, characterData: true, subtree: true });
      labelObservers.push(observer);
    });
  }

  function bindVariantSelectListeners() {
    document.querySelectorAll('variant-selects.custom-variant-flex').forEach(function (variantSelects) {
      if (variantSelects.dataset.igGenderBound === 'true') return;
      variantSelects.dataset.igGenderBound = 'true';

      variantSelects.addEventListener('change', function () {
        runDebouncedUpdate();
      });
    });
  }

  function bindQuantityBreakListeners() {
    document.querySelectorAll('quantity-breaks, .quantity-breaks').forEach(function (root) {
      if (root.dataset.igGenderQbBound === 'true') return;
      root.dataset.igGenderQbBound = 'true';

      // Capture phase + immediate fix — shrine resets dual labels ("… Women …")
      // and an 80ms debounce lets "Women" flicker for a frame.
      function onQbChange(event) {
        var target = event.target;
        if (!target || !target.closest) return;
        if (!target.closest('.quantity-break__variant-select, .quantity-break__selector-item, .quantity-break, select')) {
          return;
        }
        setUserGender(userSelectedGender, false);
        runImmediateLabelFix();
        // Second pass after shrine finishes rebuilding option text.
        requestAnimationFrame(function () {
          runImmediateLabelFix();
          requestAnimationFrame(runImmediateLabelFix);
        });
        runDebouncedUpdate();
      }

      root.addEventListener('change', onQbChange, true);
      root.addEventListener('input', onQbChange, true);
    });
  }

  var qbObserver = null;

  function observeQuantityBreaks() {
    if (qbObserver || !window.MutationObserver || !document.body) return;

    qbObserver = new MutationObserver(function (mutations) {
      var related = false;
      var hasWomenFlash = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var nodes = [];
        if (m.addedNodes && m.addedNodes.length) {
          Array.prototype.forEach.call(m.addedNodes, function (n) {
            nodes.push(n);
          });
        }
        if (m.target) nodes.push(m.target);
        if (m.type === 'characterData' && m.target && m.target.parentElement) {
          nodes.push(m.target.parentElement);
        }
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (!node) continue;
          var text =
            (node.nodeType === 3 && node.textContent) ||
            (node.nodeType === 1 && node.textContent) ||
            '';
          if (/Women/i.test(text) && (isDualGenderSize(text.trim()) || /US\s*Men/i.test(text))) {
            hasWomenFlash = true;
          }
          if (!node || node.nodeType !== 1) continue;
          if (
            (node.matches &&
              node.matches(
                'quantity-breaks, .quantity-break, .quantity-break__variant-select, .quantity-break__selector-item, option'
              )) ||
            (node.querySelector &&
              node.querySelector(
                'quantity-breaks, .quantity-break__variant-select, .quantity-break__selector-item'
              )) ||
            (node.closest &&
              node.closest(
                'quantity-breaks, .quantity-breaks, variant-selects.custom-variant-flex'
              ))
          ) {
            related = true;
          }
        }
      }
      if (hasWomenFlash || related) {
        // Sync — must run before next paint to kill "Women" flicker.
        runImmediateLabelFix();
        bindQuantityBreakListeners();
        if (!hasWomenFlash) runDebouncedUpdate();
      }
    });

    qbObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    bindCartObserver();
    patchCartAddFetch();
    patchCartAddXHR();

    if (!productSupportsGenderToggle()) {
      removeExistingTabs();
      stopLabelObservers();
      return;
    }

    createGenderTabs();
    bindVariantSelectListeners();
    bindQuantityBreakListeners();
    observeQuantityBreaks();
    observeSizeLabels();
    syncPropertyInputs();
    // Always re-apply labels — quantity-break options are often rebuilt after first paint.
    updateVariantNames();
  }

  function boot() {
    init();
    // Shrine quantity-breaks rebuilds selects asynchronously; re-apply after those paints.
    [400, 900, 1600].forEach(function (delay) {
      setTimeout(init, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    tabsBound = false;
    boot();
  });

  document.addEventListener('variant:change', function () {
    runDebouncedUpdate();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.ig-variant-pills__btn')) {
      runImmediateLabelFix();
      runDebouncedUpdate();
      return;
    }

    if (e.target.closest('.quantity-break, .quantity-break__variant-select, .quantity-break__selector-item')) {
      setUserGender(userSelectedGender, false);
      runImmediateLabelFix();
      runDebouncedUpdate();
      return;
    }

    if (e.target.closest('.product-form__submit, sticky-atc button, sticky-atc [name="add"], .sticky-atc__button')) {
      rememberCurrentAdd();
      syncPropertyInputs();
      runDebouncedUpdate();
      scheduleCartUpdate();
    }
  });

  // Catch dual-size flash as soon as the closed <select> shows new selected text.
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (
        !t.matches(
          '.quantity-break__variant-select, quantity-breaks select, .quantity-breaks select, variant-selects select'
        )
      ) {
        return;
      }
      setUserGender(userSelectedGender, false);
      runImmediateLabelFix();
      requestAnimationFrame(runImmediateLabelFix);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      if (!isAddToCartForm(e.target)) return;
      rememberCurrentAdd();
      syncPropertyInputs();
    },
    true
  );

  window.ComfoFeetSizeGenderConverter = {
    init: init,
    getGender: function () {
      activeGender = resolveUiGender();
      return activeGender;
    },
    syncProperties: syncPropertyInputs,
    setGender: function (gender) {
      // Sticky ATC / external callers — treat as explicit user gender choice.
      setUserGender(gender, true);
      runTabSwitchUpdate();
    },
    normalizeSizeKey: normalizeSizeKey,
    version: '1.9.0',
  };
})();
